import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Call to action (link or button). */
  action?: ReactNode;
  /** Tighter vertical rhythm for small panels. */
  compact?: boolean;
  className?: string;
}

/** Quiet, centred empty state with an icon tile. */
export function EmptyState({ icon, title, description, action, compact, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center', compact ? 'py-6' : 'py-10', className)}>
      {icon && (
        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl border border-border bg-muted/60 text-muted-foreground [&_svg]:h-5 [&_svg]:w-5">
          {icon}
        </div>
      )}
      <p className="text-[13.5px] font-semibold text-foreground">{title}</p>
      {description && <p className="mt-1 max-w-xs text-[12.5px] text-muted-foreground">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
